import React, { useEffect } from 'react';
import './XR.css';
import Navbar from '../components/Navbar';

const XRinfrastructure = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      key: 'exhibits',
      title: 'Immersive Exhibits for Museums & Theme Parks',
      subtitle: 'Bring storytelling and heritage to life through interactive XR installations.',
      description: 'Bring storytelling and heritage to life through interactive XR installations in science centers, museums, and cultural spaces.',
      highlights: [
        'AR/VR-based exhibits for interactive visitor engagement',
        'Heritage reconstructions, virtual tours, and simulations',
        'Accessible, multi-language immersive content',
      ],
      image: '../images/XR spatial museum_l.webp', // Assuming image is in src/images
      alt: 'Immersive Exhibits Image',
    },
    {
      key: 'centers',
      title: 'XR Experience Centers',
      subtitle: 'Custom XR centers tailored for training, demonstrations, and innovation.',
      description: 'Showcase the future of work, learning, and collaboration with custom XR centers tailored for training, demonstrations, or innovation.',
      highlights: [
        'Turnkey setup of VR/AR spaces with hardware & software integration',
        'Control rooms, simulation pods, and multi-user interaction',
        'Scalable designs for corporates, universities, and public spaces',
      ],
      image: '../images/XR product demo_l.webp', 
      alt: 'XR Experience Centers Image',
    },
  ];

  return (
    <>
      <Navbar />
      <div className="xr-container">
        <p className="page-path">Services / XRinfrastructure</p>
        <p className="xr-intro">
          We help organizations build, upgrade, and optimize XR infrastructure—from standalone kiosks to
          full-fledged experience centers. Whether you're launching your first XR initiative or expanding
          existing capabilities, we provide the strategy, setup, and support.
        </p>

        {sections.map((section, index) => (
          <React.Fragment key={section.key}>
            <div className={`xr-section ${index % 2 === 1 ? 'reverse' : ''}`}>
              <div className="xr-content">
                <h1 className="xr-title">{section.title}</h1>
                <p className="subtitle1">{section.subtitle}</p>
                <p className="description">{section.description}</p>
                <div className="xr-highlights">
                  <h6>Highlights:</h6>
                  <ul>
                    {section.highlights.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="xr-image-wrapper">
                <img
                  src={section.image}
                  alt={section.alt || 'XR section'}
                  className="xr-image"
                />
              </div>
            </div>
            <hr className="xr-divider" />
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default XRinfrastructure;
